import React, { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap'
import { gql, useMutation } from '@apollo/client'


const CREATE_ADJUSTER = gql`
  mutation CreateAdjuster($input: CreateTPAAdjusterMutationInput!) {
    createTpaAdjuster(input: $input) {
      adjuster {
        id
        name
      }
      errors {
        field
        messages
      }
    }
  }
`

const AddAdjusterModal = ({ isOpen, toggle, tpaId, onCreate }) => {
    const [newAdjuster, setNewAdjuster] = useState({ name: '', phone: '', email: '', role: '' })
    const [localError, setLocalError] = useState(null)
    const [createAdjuster, { loading }] = useMutation(CREATE_ADJUSTER)
    const [mutationError, setMutationError] = useState(null)

    const handleCreate = async () => {
        setLocalError(null)
        setMutationError(null)
        if (!newAdjuster.name) {
            setLocalError('Adjuster name is required.')
            return
        }
        const input = { ...newAdjuster, tpaId }
        try {
            const { data } = await createAdjuster({ variables: { input } })
            if (data?.createTpaAdjuster?.adjuster) {
                onCreate && onCreate(data.createTpaAdjuster.adjuster)
                setNewAdjuster({ name: '', phone: '', email: '', role: '' })
                toggle()
            } else if (data?.createTpaAdjuster?.errors?.length > 0) {
                setMutationError(data.createTpaAdjuster.errors[0].messages[0])
            }
        } catch (e) {
            setMutationError(e.message)
        }
    }

    const handleChange = (field, value) => {
        setNewAdjuster(prev => ({ ...prev, [field]: value }))
    }

    const handleClose = () => {
        setNewAdjuster({ name: '', phone: '', email: '', role: '' })
        setLocalError(null)
        setMutationError(null)
        toggle()
    }

    return (
        <Modal isOpen={isOpen} toggle={handleClose}>
            <ModalHeader>Create Adjuster</ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="name">Name*</Label>
                    <Input
                        id="name"
                        value={newAdjuster.name}
                        onChange={e => handleChange('name', e.target.value)}
                        placeholder="Enter adjuster name"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="adjusterPhone">Phone</Label>
                    <Input
                        id="adjusterPhone"
                        value={newAdjuster.phone}
                        onChange={e => handleChange('phone', e.target.value)}
                        placeholder="Enter adjuster phone"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="adjusterEmail">Email</Label>
                    <Input
                        id="adjusterEmail"
                        value={newAdjuster.email}
                        onChange={e => handleChange('email', e.target.value)}
                        placeholder="Enter adjuster email"
                    />
                </FormGroup>
                <FormGroup>
                    <Label for="adjusterRole">Role</Label>
                    <Input
                        id="adjusterRole"
                        value={newAdjuster.role}
                        onChange={e => handleChange('role', e.target.value)}
                        placeholder="Enter adjuster role"
                    />
                </FormGroup>
                {(localError || mutationError) && <div className="text-danger small mb-2">{localError || mutationError}</div>}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleClose} disabled={loading}>Cancel</Button>
                <Button color="primary" onClick={handleCreate} disabled={loading}>
                    {loading ? 'Creating...' : 'Create'}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AddAdjusterModal
